import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from "primereact/checkbox";
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { getDataApi1, loadApi, saveApi, loadApi1, saveApi1, delApi1} from "../services/appApi";
import axios from "axios";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const Clients  = () => {

  let emptyRow = {
    address_city: null,
    address_country_code: null,
    address_foreign_flag: null,
    address_line1: null,
    address_line2: null,
    address_province_name: null,
    address_state: null,
    address_zip: null,
    business_dba_name: null,
    business_email_address: null,
    business_federal_tax_id: null,
    business_legal_name: null,
    business_phone_number: null,
    client_contact_cell_phone: null,
    client_contact_email_address: null,
    client_contact_home_phone: null,
    client_contact_work_phone: null,
    client_federal_tax_id: null,
    client_federal_tax_id_type: "",
    client_first_name: "",
    client_id: null,
    client_last_name: null,
    client_middle_name: null,
    client_type_desc: null,
    client_type_lkcd: "",
    client_type_mean: null,
    created_by: null,
    creation_date: "",
    firm_id: null,
    last_update_date: "",
    last_updated_by: null,
    spouse_contact_cell_phone: null,
    spouse_contact_email_address: null,
    spouse_contact_home_phone: null,
    spouse_contact_work_phone: null,
    spouse_federal_tax_id: null,
    spouse_federal_tax_id_type: "",
    spouse_first_name: null,
    spouse_last_name: null,
    spouse_middle_name: null
  };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filters, setFilters] = useState({
      client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
    });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);
  const [currentMode, setCurrentMode] = useState(''); 
  const [firmNameOptions, setFirmNameOptions] = useState([]);
  const [fetchFirmFlag, setFetchFirmFlag] = useState(false);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const userId = localStorage.getItem("taxUserId");
  const firmId = localStorage.getItem("taxFirmId");

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_firm_clients_v/v1/?p_user_id=${encodeURIComponent(userId || "")}&p_firm_id=${encodeURIComponent(firmId || "")}&offset=${offset}&limit=${limit}`);
        console.log("Response: ", response);
        allData = [...allData, ...response.data.o_return_data_rc];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
         if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };

    useEffect(() => {
      const fetchFirm = async () => {
        setFetchFirmFlag(true);
        try {
          let offset = 0;
          let limit = 25;
          let hasMore = true;
          let allData = [];
          let status = null;
          while (hasMore) {
            const response = await getDataApi1(
              `/ztx_firms_v/?offset=${offset}&limit=${limit}`,
            );
            allData = [...allData, ...response.data.items];
            status = response.status;
            hasMore = response.data.hasMore;
            offset = offset + limit;
          }
          if (allData.length > 0) {
            const options = allData.map((item) => ({
              label: item.legal_name,
              value: item.firm_id,
            }));
            setFirmNameOptions(options);
            console.log(options);
            setFetchFirmFlag(false);
          }
        } catch (err) {
          console.error(err);
          setFetchFirmFlag(false);
        }
      };
      fetchFirm();
    }, []);
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showNewProduct = () => {
    setRow(emptyRow);
    setCurrentMode('I');
    setShowProductDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R');
    setShowProductDialog(true);
}

const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U');
    setShowProductDialog(true);
  };
const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">Clients Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      Clients
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <Button
        // label="New"
        icon="pi pi-plus"
        className="p-button-success p-button-rounded p-mr-2"
        onClick={showNewProduct}
        tooltip="New"
        tooltipOptions={{ position: "bottom" }}
      />
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const editBodyTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-secondary"
            onClick={() => showEditProduct(rowData)}
            tooltip="Edit"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
  };
 
  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

   const saveData = async (currentMode) => {
      if(currentMode === 'I') {
      try {
        const p_param = {
            p_user_id: Number(userId),                                                                        
            p_firm_id: firmId,                                                                 
            p_client_type_lkcd: row.client_type_lkcd,                                                   
            p_business_legal_name: row.business_legal_name,                                             
            p_business_dba_name: row.business_dba_name,                                                 
            p_business_federal_tax_id: row.business_federal_tax_id,                                     
            p_business_phone_number: row.business_phone_number,                                         
            p_business_email_address: row.business_email_address,                                       
            p_client_first_name: row.client_first_name,                                                 
            p_client_middle_name: row.client_middle_name,                                               
            p_client_last_name: row.client_last_name,                                                   
            p_spouse_first_name: row.spouse_first_name,                                                 
            p_spouse_middle_name: row.spouse_middle_name,                                               
            p_spouse_last_name: row.spouse_last_name,                                                   
            p_client_federal_tax_id: row.client_federal_tax_id,                                         
            p_client_federal_tax_id_type: row.client_federal_tax_id_type,                               
            p_spouse_federal_tax_id: row.spouse_federal_tax_id,                                         
            p_spouse_federal_tax_id_type: row.spouse_federal_tax_id_type,                               
            p_client_contact_cell_phone: row.client_contact_cell_phone,                                 
            p_client_contact_work_phone: row.client_contact_work_phone,                                 
            p_client_contact_home_phone: row.client_contact_home_phone,                                 
            p_client_contact_email_address: row.client_contact_email_address,                           
            p_spouse_contact_cell_phone: row.spouse_contact_cell_phone,                                 
            p_spouse_contact_work_phone: row.spouse_contact_work_phone,                                 
            p_spouse_contact_home_phone: row.spouse_contact_home_phone,                                 
            p_spouse_contact_email_address: row.spouse_contact_email_address,                           
            p_address_line1: row.address_line1,                                                         
            p_address_line2: row.address_line2,                                                         
            p_address_city: row.address_city,                                                           
            p_address_state: row.address_state,                                                         
            p_address_zip: row.address_zip,                                                             
            p_address_foreign_flag: row.address_foreign_flag,                                           
            p_address_country_code: row.address_country_code,                                           
            p_address_province_name: row.address_province_name, 
        };
        console.log("Insert p_param: ", p_param);
        const response = await loadApi1(
          p_param,
          "/ztx_firm_clients/v1/",
        );
        console.log(response);
        console.log(response.data);
        if (response.data.o_success_flag === "Y") {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data Inserted",
          });
          const newRow = {
            client_id: response.data.o_client_id,
            ...row,
          };
          setRows((prev) => [...prev, newRow]);
          setShowProductDialog(false);
          setCurrentMode('');
          setRow(emptyRow);
        } else {
          const err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "Data Not Inserted",
            life: 3000,
            width: "600px",
          });
          setErrorMessage(err_msg);
          setErrorDialogVisible(true);
        }
      } catch (error) {
        if (axios.isCancel(error) || error.name == "CanceledError") {
          toast.current.show({
            severity: "warn",
            summary: "Cancelled",
            detail: "Request successfully cancelled by the user.",
            life: 3000,
          });
        } else {
          // Set the error message and display the dialog
          setErrorMessage(error.message);
          setErrorDialogVisible(true);
        }
      }
    } else if (currentMode === 'U'){
  
       const p_param = {                                                                              
            p_user_id: Number(userId),  
            p_firm_id: row.firm_id,                                                                                
            p_client_id: row.client_id,                                                                        
            p_client_type_lkcd: row.client_type_lkcd,                                                   
            p_business_legal_name: row.business_legal_name,                                             
            p_business_dba_name: row.business_dba_name,                                                 
            p_business_federal_tax_id: row.business_federal_tax_id,                                     
            p_business_phone_number: row.business_phone_number,                                         
            p_business_email_address: row.business_email_address,                                       
            p_client_first_name: row.client_first_name,                                                 
            p_client_middle_name: row.client_middle_name,                                               
            p_client_last_name: row.client_last_name,                                                   
            p_spouse_first_name: row.spouse_first_name,                                                 
            p_spouse_middle_name: row.spouse_middle_name,                                               
            p_spouse_last_name: row.spouse_last_name,                                                   
            p_client_federal_tax_id: row.client_federal_tax_id,                                         
            p_client_federal_tax_id_type: row.client_federal_tax_id_type,                               
            p_spouse_federal_tax_id: row.spouse_federal_tax_id,                                         
            p_spouse_federal_tax_id_type: row.spouse_federal_tax_id_type,                               
            p_client_contact_cell_phone: row.client_contact_cell_phone,                                 
            p_client_contact_work_phone: row.client_contact_work_phone,                                 
            p_client_contact_home_phone: row.client_contact_home_phone,                                 
            p_client_contact_email_address: row.client_contact_email_address,                           
            p_spouse_contact_cell_phone: row.spouse_contact_cell_phone,                                 
            p_spouse_contact_work_phone: row.spouse_contact_work_phone,                                 
            p_spouse_contact_home_phone: row.spouse_contact_home_phone,                                 
            p_spouse_contact_email_address: row.spouse_contact_email_address,                           
            p_address_line1: row.address_line1,                                                         
            p_address_line2: row.address_line2,                                                         
            p_address_city: row.address_city,                                                           
            p_address_state: row.address_state,                                                         
            p_address_zip: row.address_zip,                                                             
            p_address_foreign_flag: row.address_foreign_flag,                                           
            p_address_country_code: row.address_country_code,                                           
            p_address_province_name: row.address_province_name,                                                                        
      
       };    
     
      console.log("Edit p_param: ", p_param);
      try {
        const response = await saveApi1(
          p_param,
          `/ztx_firm_clients/v1/`,
        );
        console.log(response);
        if (response.data.o_success_flag === "Y") {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data Updated",
          });
          setRows((prev) =>
            prev.map((data) =>
              data.client_id === row.client_id
                ? { ...row }
                : data,
            ),
          );
          setShowProductDialog(false);
          setCurrentMode('');
        } else {
          const err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "Data Not Updated",
            life: 3000,
            width: "600px",
          });
          setErrorMessage(err_msg);
        }
  
        //setRows(response.data);
      } catch (error) {
        if (axios.isCancel(error) || error.name == "CanceledError") {
          toast.current.show({
            severity: "warn",
            summary: "Cancelled",
            detail: "Request successfully cancelled by the user.",
            life: 3000,
          });
        } else {
          // Set the error message and display the dialog
          setErrorMessage(error.message);
          setErrorDialogVisible(true);
        }
      }
    }
    };

    const hideDeleteRowDialog = () => {
      setDeleteRowDialog(false);
    };

    const confirmDeleteRow = (row) => {
      setRow(row);
      setDeleteRowDialog(true);
    };

    const deleteRow = async () => {
      const p_param = {
        p_user_id: Number(userId),
        p_firm_id: row.firm_id ,
        p_client_id: row.client_id,
      };
      try {
        const response = await delApi1(
          { params: p_param },
          "/ztx_firm_clients/v1/",
        );
        let successFlag = response.data.o_success_flag;
        if (successFlag === "Y") {
          let _rows = rows.filter((val) => val.client_id !== row.client_id);
          setRows(_rows);
          setDeleteRowDialog(false);
          setRow(emptyRow);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Client Deleted",
            life: 3000,
            width: "600px",
          });
        } else {
          let err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "Client Not Deleted",
            life: 3000,
            width: "600px",
          });
        }
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Client Deletion Failed",
          life: 3000,
          width: "600px",
        });
      }
    };

    const deleteRowDialogFooter = (
      <React.Fragment>
        <Button
          label="No"
          icon="pi pi-times"
          severity="secondary"
          onClick={hideDeleteRowDialog}
        />
        <Button label="Yes" icon="pi pi-check" onClick={deleteRow} />
      </React.Fragment>
    );

    const actionBodyDeleteTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-warning"
            onClick={() => confirmDeleteRow(rowData)}
            tooltip="Delete"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
    };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">Clients</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
        >
         
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={editBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={actionBodyDeleteTemplate} style={{ width: "0.75rem" }} ></Column>
          {/* <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} filterElement={clientFilterTemplate}></Column> */}
          <Column field="client_first_name" header="First Name" sortable></Column>
          <Column field="client_last_name" header="Last Name" sortable></Column>
          {/* <Column field="client_type_desc" header="Description" sortable></Column> */}
        </DataTable>
      </div>
      )}

      {/* <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="Clients" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="client_first_name">First Name</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="client_last_name">Last Name</label>
                    <div className="box">
                        {row.client_last_name}
                    </div> */}

                {/* <label htmlFor="client_type_desc">Description</label>
                    <div className="box">
                        {row.client_type_desc}
                    </div> */}

            {/* </Dialog> */}
            <Dialog
              // header="Add Clients"
              header={currentMode === 'I' ? "Add Clients" : currentMode === 'U' ? "Update Clients" : currentMode === 'R' ? "View Clients" : "Clients"}
              visible={showproductDialog}
              style={{ width: "40rem" }}
              onHide={() => setShowProductDialog(false)}
            >
              <div className="p-fluid">
                
                <div className="field">
                  <label>Client Type Lkcd</label>
                  <InputText
                    value={row.client_type_lkcd}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, client_type_lkcd: e.target.value })}
                  />
                </div>
                {/* <div className="field">
                  <label>Firm</label>
                  <Dropdown
                    value={row.firm_id}
                    disabled = {currentMode === 'R' ? true : false}
                    options={firmNameOptions}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Firm"
                    onChange={(e) => {
                      const selectedOption = firmNameOptions.find(
                        (option) => option.value === e.value,
                      );
                      setRow({
                        ...row,
                        firm_id: e.value,
                        legal_name: selectedOption?.label || "",
                      });
                    }}
                  />
                </div> */}
                <div className="field">
                  <label>Business Legal Name</label>
                  <InputText
                    value={row.business_legal_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, business_legal_name: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Business dba Name</label>
                  <InputText
                    value={row.business_dba_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, business_dba_name: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Business Federal Tax Id</label>
                  <InputText
                    value={row.business_federal_tax_id}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, business_federal_tax_id: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Business Phone Number</label>
                  <InputText
                    value={row.business_phone_number}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, business_phone_number: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Business Email Address</label>
                  <InputText
                    value={row.business_email_address}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, business_email_address: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>First Name</label>
                  <InputText
                    value={row.client_first_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, client_first_name: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Middle Name</label>
                  <InputText
                    value={row.client_middle_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, client_middle_name: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Last Name</label>
                  <InputText
                    value={row.client_last_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, client_last_name: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Spouse First Name </label>
                  <InputText
                    value={row.spouse_first_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, spouse_first_name: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Spouse Middle Name </label>
                  <InputText
                    value={row.spouse_middle_name}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, spouse_middle_name: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Client Federal Tax ID </label>
                  <InputText
                    value={row.client_federal_tax_id}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, client_federal_tax_id: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Client Federal Tax ID Type</label>
                  <InputText
                    value={row.client_federal_tax_id_type}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, client_federal_tax_id_type: e.target.value })}
                  />
                </div>
                
                <div className="field">
                  <label>Spouse Federal Tax ID Type</label>
                  <InputText
                    value={row.spouse_federal_tax_id}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, spouse_federal_tax_id: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Spouse Federal Tax ID Type</label>
                  <InputText
                    value={row.spouse_federal_tax_id_type}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, spouse_federal_tax_id_type: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Contact Cell Phone</label>
                  <InputText
                    value={row.client_contact_cell_phone}
                    disabled = {currentMode === 'R' ? true : false}
                    onChange={(e) => setRow({ ...row, client_contact_cell_phone: e.target.value })}
                  />
                </div>
                <div className="field">
                  <label>Client Contact Home Phone</label>
                  <InputText
                    value={row.client_contact_home_phone}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, client_contact_home_phone: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Client Contact Email Address</label>
                  <InputText
                    value={row.client_contact_email_address}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, client_contact_email_address: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Spouse Contact Cell Phone</label>
                  <InputText
                    value={row.spouse_contact_cell_phone}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, spouse_contact_cell_phone: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Spouse Contact Work Phone</label>
                  <InputText
                    value={row.spouse_contact_work_phone}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, spouse_contact_work_phone: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Spouse Contact Home Phone</label>
                  <InputText
                    value={row.spouse_contact_home_phone}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, spouse_contact_home_phone: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Spouse Contact Email Address</label>
                  <InputText
                    value={row.spouse_contact_email_address}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, spouse_contact_email_address: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Address Line1</label>
                  <InputText
                    value={row.address_line1}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, address_line1: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Address Line2</label>
                  <InputText
                    value={row.address_line2}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, address_line2: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Address City</label>
                  <InputText
                    value={row.address_city}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, address_city: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Address State</label>
                  <InputText
                    value={row.address_state}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, address_state: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Address Zip</label>
                  <InputText
                    value={row.address_zip}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, address_zip: e.target.value })}
                  />
                </div>
                <div className="field">
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    <label>Address Foreign Flag</label>
                    <Checkbox
                      checked={row.address_foreign_flag === "Y"}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) =>
                        setRow({
                          ...row,
                          address_foreign_flag: e.checked ? "Y" : "N",
                        })
                      }
                    />
                  </div>
                </div>

                <div className="field">
                  <label>Address Country Code</label>
                  <InputText
                    value={row.address_country_code}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, address_country_code: e.target.value })}
                  />
                </div>

                <div className="field">
                  <label>Address Province Name</label>
                  <InputText
                    value={row.address_province_name}
                    disabled={currentMode === 'R'}
                    onChange={(e) => setRow({ ...row, address_province_name: e.target.value })}
                  />
                </div>
                
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.5rem",
                  }}
                >
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    severity="secondary"
                    onClick={() => {
                      setShowProductDialog(false);
                      setRow(emptyRow);
                      setCurrentMode('');
                    }}
                  />
                  <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
                </div>
              </div>
            </Dialog>
                  <Dialog
                    visible={deleteRowDialog}
                    style={{ width: "450px" }}
                    header="Confirm"
                    modal
                    footer={deleteRowDialogFooter}
                    onHide={hideDeleteRowDialog}
                  >
                    <div className="confirmation-content">
                      <i
                        className="pi pi-exclamation-triangle p-mr-3"
                        style={{ fontSize: "1.25rem", marginRight: "0.5rem" }}
                      />
                      {row && (
                        <span>
                          Are you sure you want to delete <b>{row.client_first_name || row.client_id}</b>?
                        </span>
                      )}
                    </div>
                  </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default Clients;